import { Component, OnInit , Input, Output, EventEmitter } from '@angular/core';

import { IonicPage, NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { ProductosProvider } from '../../providers/productos/productos'
import { ProveedoresProvider } from '../../providers/proveedores/proveedores'
import { ProveedoresCargarStockProvider } from '../../providers/proveedores-cargar-stock/proveedores-cargar-stock'
import { Observable } from 'rxjs/Observable';
import { seguimientoIngresosStock } from '../../models/seguimientoIngresosStock'
import { Storage } from '@ionic/storage'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { SeguimientoIngresosStockProvider } from '../../providers/seguimiento-ingresos-stock/seguimiento-ingresos-stock'
import { ElectronService } from 'ngx-electron';
import { MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO,URL_SERVICIOS_LOCALESFRONT,URL_SERVICIOS_LOCALESBACK, NUBE_AWS } from "../../config/url.servicio"
import { SelectSearchable } from 'ionic-select-searchable';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { lotes } from '../../models/lotes'
import { PushProvider } from '../../providers/push/push'
import { InformesProvider } from '../../providers/informes/informes'
import { UtilsProvider } from '../../providers/utils/utils'
import { CompaniasProvider } from '../../providers/companias/companias';
import { CajaProvider } from '../../providers/caja/caja';

@IonicPage()
@Component({
  selector: 'page-grid-proveedores',
  templateUrl: 'grid-proveedores.html',
  providers: [InAppBrowser,PushProvider]
})
export class GridProveedoresPage implements OnInit {
  listaProveedores: any = []
  listaProveedoresGrid: any = []
  listaProductos: any = []
  listaProductosCopiaAlmacenarTipo: any = []
  listaProductosCopia: any = []
  public proveedorId:any

  public productosId:any
  public productosIdParaGuardar:any
  public arrayWhere : any = [{"":""}];
  recibo:string = "";
  cerradoEnCaja:string= "N";
  @Input() arrayWherelocal : any = []
  jsoncolumnanuevo = [];
  datosWhere: any = [];
  valorWhere: any = [];
  nuevacondicion: any = [];
  datosproveedores: seguimientoIngresosStock[] = [];
  ValoresWhereConsultaarray = [];
  WhereCampo:Array<Object> = [];
  WhereCondicion:Array<Object> = [];
  WhereValor:Array<Object> = [];
  WhereCondicionFinal:Array<Object> = [];
  consultar: string = "";
  loader
  consultaagregadoArray: Array<Object> = [];

  fecha:string=""
  valoresTotales:number=0
  pagoTotal:boolean=false
  lote:lotes[] = []
  manejaLotesEnProductos:string ="N"
  manejaLotesEnProductosValor:boolean = false
  fechacaducidad:string=""
  campoUnico = []
  public codigoBarra:any =""
  buscarTexto: string = '';
  codigoProducto
  showBuscarProducto: boolean = false;
  paginaActual: number = 1;
  manejaCodigoDeBarraEnCargarStock:boolean = false
  actualizaCostoDelProductoEnCargarStock:boolean = false
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicioProveedores:ProveedoresProvider,
              public servicioProductos: ProductosProvider,
              public servicioStock:ProveedoresCargarStockProvider,
            private storage:Storage,
              public utilidades:ClientesProvider,
              public seguimientoIngresosStockProviders:SeguimientoIngresosStockProvider,
              public alertControllers: AlertController,
              public loaders:LoadingController,
              private _electronService: ElectronService,
              private iab: InAppBrowser,
              public servicioPush:PushProvider,
              public informes: InformesProvider,
              public utils: UtilsProvider,
              public servicioCompania:CompaniasProvider,
              public servicioCaja: CajaProvider,) {

                if(MODO_DESCONECTADO){
                  console.log('entro en modo desconectado....')
                  this.elect()
                  //this.buscarProductos()
                  //this.buscarProveedores()
                  this.nuevacondicion.push({"":""})
                }else{
                  this.buscarProductos()
                  this.buscarProveedores()
                  this.buscarGridProveedores()
                  this.nuevacondicion.push({"":""})
                  this.buscarDatosProveedor("")
                  this.buscarParametrosGenerales()
                }


 }

 ngOnInit(): void {
  let datosGenerales = localStorage.getItem('datosGenerales')
  let datosGeneralesJSON = JSON.parse(datosGenerales)
  if(datosGeneralesJSON && datosGeneralesJSON["manejaCodigoDeBarraEnCargarStock"]) {
    this.manejaCodigoDeBarraEnCargarStock = datosGeneralesJSON["manejaCodigoDeBarraEnCargarStock"].seleccion === 'S' ? true : false
  }
  if(datosGeneralesJSON && datosGeneralesJSON["actualizaCostoDelProductoEnCargarStock"]) {
    this.actualizaCostoDelProductoEnCargarStock = datosGeneralesJSON["actualizaCostoDelProductoEnCargarStock"].seleccion === 'S' ? true : false
  }
 }

 elect(){
  let resultadolistaProductos = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-listaProductos',RUTA_MODO_DESCONECTADO)

  if(!resultadolistaProductos){

    this.listaProductos =JSON.parse(resultadolistaProductos)
  }else {

      this.listaProductos =JSON.parse(resultadolistaProductos)
  }

  let resultadolistaProveedores = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-listaProveedores',RUTA_MODO_DESCONECTADO)

  if(!resultadolistaProveedores){

    this.listaProveedores =JSON.parse(resultadolistaProveedores)
  }else {

      this.listaProveedores =JSON.parse(resultadolistaProveedores)
  }

}

buscarProductos(){

    this.storage.get('companiasId').then((val) => {
      this.servicioCaja.buscarGruposProductosParaCajaTendero(val).subscribe(
          res => {


                  let listaGruposProductosTemporal = []
                  let resData = []
                  if(NUBE_AWS){
                    resData =  JSON.parse(res['_body']).data[0]
                  } else {
                    resData = res[0]
                  }
                  for(let k=0;k<resData.length;k++){
                      let imagenNueva =resData[k].imagenLocal
                       listaGruposProductosTemporal.push({
                          gruposProductosId:resData[k].gruposProductosId,
                          codigoGrupoProducto:resData[k].codigoGrupoProducto,
                          nombreGrupoProducto:resData[k].nombreGrupoProducto,
                          companiasId:resData[k].companiasId,
                          imagen:resData[k].imagen,
                          imagenLocal: resData[k].imagenLocal
                      })
                  }
                  // this.listaGruposProductos = listaGruposProductosTemporal

                  let listaProductosTemporal = []
                  let resProductoData = []
                  if(NUBE_AWS){
                    resProductoData =  JSON.parse(res['_body']).data[1]
                  } else {
                    resProductoData = res[1]
                  }

                  for(let y=0;y<resProductoData.length;y++){

                       listaProductosTemporal.push({
                          gruposProductosId:resProductoData[y].gruposProductosId,
                          imagen:resProductoData[y].imagen,
                          imagenLocal:resProductoData[y].imagenLocal,
                          nombreProducto:resProductoData[y].nombreProducto,
                          productosId:resProductoData[y].productosId,
                          tipoProducto:resProductoData[y].tipoProducto,
                          valorImpuesto:resProductoData[y].valorImpuesto,
                          valorProducto:resProductoData[y].valorProducto,
                          valorVenta:resProductoData[y].valorVenta,
                          existenciasActuales:resProductoData[y].existenciasActuales,
                          nombreUbicacion:resProductoData[y].nombreUbicacion,
                          nombreContenedor:resProductoData[y].nombreContenedor,
                          valorImpuestoCalculo:resProductoData[y].valorImpuestoCalculo
                          ,codigoBarra: resProductoData[y].codigoBarra,
                          concatenado:resProductoData[y].concatenado,
                          display:resProductoData[y].display,
                          unidad:resProductoData[y].unidad,
                          tipoImpuesto: resProductoData[y].tipoImpuesto
                        })
                  }

                  let listaProductosTemporalDinamico = []
                  let resProductoDataDinamico = []
                  if(NUBE_AWS){
                    resProductoDataDinamico =  JSON.parse(res['_body']).data[3]
                  } else {
                    resProductoDataDinamico = res[3]
                  }

                  for(let y=0;y<resProductoDataDinamico.length;y++){
                      listaProductosTemporalDinamico.push({
                          imagen:resProductoDataDinamico[y].imagen,
                          imagenLocal:resProductoDataDinamico[y].imagenLocal,
                          nombreProducto:resProductoDataDinamico[y].nombreProducto,
                          productosId:resProductoDataDinamico[y].productosId,
                          tipoProducto:'E',
                          valorImpuesto:resProductoDataDinamico[y].valorImpuesto,
                          valorProducto:resProductoDataDinamico[y].valorProducto,
                          valorVenta:resProductoDataDinamico[y].valorVenta,
                          valorImpuestoCalculo:resProductoDataDinamico[y].valorImpuestoCalculo
                      })
                  }

                  this.storage.set('datosDinamicos',JSON.stringify(resProductoDataDinamico))

                  this.listaProductos = listaProductosTemporal

                  console.log('no es android')
              }
      )
  })
}



  ionViewDidLoad() {
    let datosGenerales = localStorage.getItem('datosGenerales')
    let datosGeneralesJSON = JSON.parse(datosGenerales)
    if(datosGeneralesJSON && datosGeneralesJSON["manejaCodigoDeBarraEnCargarStock"]) {
      this.manejaCodigoDeBarraEnCargarStock = datosGeneralesJSON["manejaCodigoDeBarraEnCargarStock"].seleccion === 'S' ? true : false
    }
    if(datosGeneralesJSON && datosGeneralesJSON["actualizaCostoDelProductoEnCargarStock"]) {
      this.actualizaCostoDelProductoEnCargarStock = datosGeneralesJSON["actualizaCostoDelProductoEnCargarStock"].seleccion === 'S' ? true : false
    }
  }

  limpiar(){
    this.arrayWhere  = [{"":""}];
    this.arrayWherelocal  = []
    this.jsoncolumnanuevo = [];
    this.datosWhere = [];
    this.valorWhere = [];
    this.nuevacondicion = [];
    this.ValoresWhereConsultaarray = [];
    this.WhereCampo = [];
    this.WhereCondicion = [];
    this.WhereValor = [];

    this.WhereCondicionFinal = [];
    this.consultar = "";
    this.datosproveedores = []
    this.lote = []
    this.productosId = undefined
    this.recibo = "";
    this.cerradoEnCaja = "N";
    this.agregarComponente(0,0,'');
  }

  agregarComponente(costounitario:any,cantidad:any,fechacaducidad:any){
      if(this.proveedorId==undefined){
        this.utils.mensajeMuestroConCerrado('Proveedor','El proveedor es requerido verifique...','Advertencia',true)
        return false
      }
      if(costounitario.value==""){
        this.utils.mensajeMuestroConCerrado('Costo','El costo del producto es requerido verifique...','Advertencia',true)
        return false
      }
      if(fechacaducidad===undefined && this.manejaLotesEnProductos==='S' ){
        this.utils.mensajeMuestroConCerrado('Fecha caducidad','La fecha de caducidad es requerida el sistema va a permitir guardar, pero no va a controlar los productos por lotes...','Advertencia',true)
      }
      if(cantidad.value==""){
        this.utils.mensajeMuestroConCerrado('Cantidad','La cantidad es requerido verifique...','Advertencia',true)
        return false
      }

    this.storage.get('usuariosId').then((usuarioIngreso) => {

      var f = new Date();
      let fechaSinFormato = f.getFullYear() + "-" + (f.getMonth() +1) + "-" + f.getDate()

      let fecha = this.utilidades.formatearCadena(fechaSinFormato)
      let fechacadu =""

      if(this.manejaLotesEnProductos==='S'){
        if(fechacaducidad===""){
          fechacadu = this.devolverFecha()
        }else{
          fechacadu =  fechacaducidad['_value'].year + "-" + fechacaducidad['_value'].day + "-" + fechacaducidad['_value'].month
        }
      }

      this.datosproveedores.push({
        proveedoresId:this.proveedorId[0].value,
        productosId:  this.productosId,
        cantidad: cantidad.value,
        fechaIngreso: fecha ,
        usuarioIngreso: usuarioIngreso,
        costoUnitario: costounitario.value,
        queHago: "I",
        name: "dataDynamicCrud",
        nombreTabla:"seguimientoIngresosStock",
        recibo: this.recibo,
        cerradoEnCaja: this.cerradoEnCaja
      }
    )

    this.campoUnico = this.datosproveedores.map(item => {
      return {
        productoCostoCantidadFecha: `${item.productosId}-${item.costoUnitario}-${item.cantidad}`
      };
    });



    if(this.manejaLotesEnProductos==='S'){
    this.lote.push({
      codigoLote:this.recibo,
      fechaElaboracion:fecha,
      fechaCaducidad:fechacadu,
      productosId: this.productosId,
      cantidadInicial: cantidad.value,
      estado: "1",
      queHago: "I",
      name:  "dataDynamicCrud",
      nombreTabla: "lotes"
    })
  }
  })

  this.listaProductosCopia = []
    this.nuevacondicion.push({"":""})
    this.productosIdParaGuardar = undefined
  }

guardar(){
  this.loader = this.loaders.create({});
  this.loader.present();
  let cantidadProveedores = this.datosproveedores.length - 1

  this.datosproveedores.map((value,item)=> {
    let datoscopia = {}

    datoscopia['proveedoresId'] = value['proveedoresId'],
    datoscopia['productosId'] = Number(value['productosId']),
    datoscopia['cantidad'] = Number(value['cantidad']),
    datoscopia['fechaIngreso'] = value['fechaIngreso'] ,
    datoscopia['usuarioIngreso'] = value['usuarioIngreso'],
    datoscopia['costoUnitario'] = Number(value['costoUnitario']),
    datoscopia['queHago'] = value['queHago'],
    datoscopia['name'] = value['name'],
    datoscopia['nombreTabla'] = value['nombreTabla']
    datoscopia['recibo'] = value['recibo']
    datoscopia['cerradoEnCaja'] = "N"
    if(!MODO_DESCONECTADO){
    this.seguimientoIngresosStockProviders.guardar(datoscopia)
    .subscribe(
      res => {

        let id = datoscopia['productosId']
        this.seguimientoIngresosStockProviders.buscarProductoPorId(id)
        .subscribe(async (data)=>{
          let actualizarproductosExistencia = {}
          let datos = !NUBE_AWS ? JSON.parse(data['_body']) : JSON.parse(data['_body']).data
          let valores = datos[0]
          actualizarproductosExistencia['queHago'] = 'A'
          actualizarproductosExistencia['productosId'] = valores[0].productosId
          actualizarproductosExistencia['nombreTabla'] = 'productos'
          let cantidad = datoscopia['cantidad'] + valores[0].existenciasActuales
          actualizarproductosExistencia['existenciasActuales'] = cantidad
          actualizarproductosExistencia['name'] = datoscopia['name']
          let companiasId = await localStorage.getItem('companiasId')
          actualizarproductosExistencia['companiasId'] = companiasId
          this.seguimientoIngresosStockProviders.actualizarExistenciaProducto(actualizarproductosExistencia)
            .subscribe((data)=> {

              if(cantidadProveedores === item){
                if(this.manejaLotesEnProductos==='S'){
                this.storage.get('companiasId').then((val) => {

                  let lotes = this.lote

                  for(var k=0;k<lotes.length;k++){
                  lotes[k]['companiasId'] = val
                  let lotesguardar = lotes[k]
                  this.seguimientoIngresosStockProviders.guardar(lotesguardar).subscribe((data)=>{
                    console.log('guardo el lote')
                    this.lote = []
                  },(error)=>{
                    this.lote = []
                    console.log(error)
                  })
                }

                })
              }

                this.buscarDatosProveedor("")
              }
            },error=>{
              console.log(error)
            })

        },error=>{
          console.log(error)
        })

      },
      err => {
        this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
      }
    )



  }
    else{
     datoscopia['usuarioIngreso'] = 1

     let result = this.seguimientoIngresosStockProviders.guardarModoDesconectado(datoscopia)
     if(result){
      this.mostrarMensaje(result,'')
      this.nuevacondicion = []
      this.nuevacondicion.push({"":""})
      this.recibo=""
      this.loader.dismiss()
      this.datosproveedores = []
      return false
     }
    }
  })
  this.nuevacondicion = []
  this.nuevacondicion.push({"":""})
  this.recibo=""
  this.loader.dismiss()
  //this.buscarGridProveedores()
  this.datosproveedores = []
  this.mostrarMensaje('Registros guardados con exito...','')
}

buscarDatosProveedor(fechaNueva:any){
  this.fecha = fechaNueva

this.storage.get('companiasId').then((val) => {

    if(this.fecha===""){
      this.fecha = this.devolverFecha()
    }

      this.seguimientoIngresosStockProviders.buscarSeguimientoIngresosStockDiarios(this.fecha,val)
      .subscribe((data)=>{
        if(NUBE_AWS) {
          let valores = JSON.parse(data['_body']).data
          this.listaProveedoresGrid = valores[0]
           let valoresCadena = valores[0].length > 0 ? JSON.stringify(valores[0]) : []
          this.valoresTotales = valores[0].length > 0 ? valores[1][0].valor : 0
          if(this.listaProveedoresGrid.length==0){
           this.pagoTotal = false
          }else{
            this.pagoTotal = true
          }
          this.seguimientoIngresosStockProviders.buscarTodosLosinformes(valoresCadena,'datosStock',URL_SERVICIOS_LOCALESBACK)
        } else {
          let valores = JSON.parse(data['_body'])
          this.listaProveedoresGrid = valores[0]
           let valoresCadena = JSON.stringify(valores[0])
          this.valoresTotales = valores[1][0].valor
          if(this.listaProveedoresGrid.length==0){
           this.pagoTotal = false
          }else{
            this.pagoTotal = true
          }
            this.seguimientoIngresosStockProviders.buscarTodosLosinformes(valoresCadena,'datosStock',URL_SERVICIOS_LOCALESBACK)
        }
     },
      (error)=>{
        console.log(error)
      })

  })
}

cambiarvaloresTotales(){
  this.pagoTotal = !this.pagoTotal
}


descargarArchivo(){
  this.storage.get('imprimirArchivo').then((val) => {
    if(val){
      if(NUBE_AWS) {
        if(this.listaProveedoresGrid.length==0){
          this.utils.mensajeMuestro('Favor dar clic primero en el botón buscar','Advertencia!','Advertencia')
          return false
        }
        this.informes.exportToExcel(this.listaProveedoresGrid, val)
        .then((result: any) => {
            console.log('result', result)
          }).catch((error)=> {
            console.log('error', error)
          })
      } else {
        this.iab.create(`${URL_SERVICIOS_LOCALESFRONT}/assets/${val}.xlsx`,'_system')
      }
    }else{
      this.mostrarMensaje('Debe buscar los datos antes de poder descargarlos','Verifique')
    }

  })

}

devolverFecha(): string{
  var f = new Date();
  let fechaSinFormato = f.getFullYear() + "-" +  (f.getMonth() +1) +  "-" + f.getDate()

  let fecha = this.formatearCadena(fechaSinFormato)
  return fecha

 }

 formatearCadena(cadena){
  let valorinicial = cadena.length
  let primero,segundo,ultimo
  primero = cadena.substr(0,4)
  segundo = cadena.substr(5,2)
  ultimo = cadena.substr(valorinicial - 2, valorinicial)
  if(valorinicial != 10){
    let recorrer = cadena.split('-')
    for(var i = 0; i < recorrer.length;i++) {
      if(i == 1 && recorrer[i].length == 1) {
        segundo = `0${recorrer[i]}`
      }
      if(i == 2 && recorrer[i].length == 1){
        ultimo = `0${recorrer[i]}`
      }
    }
  }
  return `${primero}-${segundo}-${ultimo}`
}


mostrarMensajeDeError(mensaje) {
  let alert = this.alertControllers.create({
    title: 'Error',
    subTitle: mensaje,
    buttons: ['Cerrar']
  });
  alert.present();
  this.loader.dismiss()
}


mostrarMensaje(mensaje,title) {
  let alert = this.alertControllers.create({
    title: title,
    subTitle: mensaje,
    buttons: ['Ok']
  });
  alert.present();
}


valoresSelect(data:string){
  this.productosId = data
}


public requestAutocompleteItems = (text: string): Observable<Response> => {
      return this.servicioStock.buscarProveedoresPorCompania(text)
};

buscarProveedores(){
  this.storage.get('companiasId').then((val) => {
  this.servicioProveedores.buscarProveedoresPorEmpresa(val)
  .subscribe((res)=> {
    if(NUBE_AWS){
      this.listaProveedores =  JSON.parse(res['_body']).data[0] === undefined ? [] : JSON.parse(res['_body']).data[0]
    } else {
      this.listaProveedores = res
    }
  })
})
}

buscarGridProveedores(){
  this.storage.get('companiasId').then((val) => {
    let companiaId = val
    this.storage.get('usuariosId').then((val) => {
  this.servicioStock.buscarGrid(companiaId,val)
  .subscribe((data)=>{
      this.listaProveedoresGrid = []
  })
})})
}

productosChange(event: { component: SelectSearchable, value: any }) {
  this.productosId = event.value.productosId
}



buscarParametrosGenerales(){

  this.storage.get('companiasId').then((val)=>{

    this.servicioPush.buscarParametrosGenerales(val)
    .subscribe((data)=>{
      if(NUBE_AWS){
        let lotes ="N"
        this.manejaLotesEnProductosValor = false
        data =  JSON.parse(data['_body']).data[0]
        if(data[0].manejaLotesEnProductos!==undefined){
          lotes = data[0].manejaLotesEnProductos
          this.manejaLotesEnProductosValor = data[0].manejaLotesEnProductos === 'S' ? true : false
        }
        this.manejaLotesEnProductos = lotes
        this.storage.set('manejaLotesEnProductos',lotes)
      } else {
        let lotes ="N"
        this.manejaLotesEnProductosValor = false
        if(data[0][0].manejaLotesEnProductos!==undefined){
          lotes = data[0][0].manejaLotesEnProductos
          this.manejaLotesEnProductosValor = data[0][0].manejaLotesEnProductos === 'S' ? true : false
        }
        this.manejaLotesEnProductos = lotes
        this.storage.set('manejaLotesEnProductos',lotes)
      }
    },(error)=>{
      console.log(error)
    })
  })
}

  editarComponente(index: any,valorventa:any=0) {
    const producto = this.datosproveedores[index];
    if(this.datosproveedores.length === 0) {
      this.utils.mensajeMuestroConCerrado('Editar producto','El costo del producto es requerido verifique...','Advertencia',true)
      return false
    }
    if (producto) {
      if(producto.costoUnitario==""){
        this.utils.mensajeMuestro('Editar producto','El costo del producto es requerido verifique...','Advertencia')
        return false
      }
      this.productosIdParaGuardar = producto.productosId
      if(this.productosIdParaGuardar == undefined){
        this.utils.mensajeMuestroConCerrado('Editar producto','Para editar el costo del un producto debe hacerlo cuando este ingresando el registro','Advertencia',true)
        return false
      }

      this.utils.mensajeConfirmacionDos('Actualizar costo','Desea actualizar el valor venta y/o costo a este producto','question','Si','No')
      .then(async (actualizarprecio: boolean) => {
        let companiaId = await localStorage.getItem('companiasId')
        if (actualizarprecio) {
          let tipoProductoArray =  this.listaProductosCopiaAlmacenarTipo.filter((item)=> item.productosId == producto.productosId)
          let tipoProducto = tipoProductoArray.length>0 ? tipoProductoArray[0].tipoProducto : 'P'

          let datos:any = {}
          datos = {
            name: 'dataDynamicCrud',
            queHago: 'A',
            costo:Number(producto.costoUnitario),
            productosId:this.productosIdParaGuardar,
            companiasId : companiaId,
            nombreTabla: ''
          }

          if(tipoProducto === 'P') {
            datos.nombreTabla = 'productos'
          } else {
            datos = {
              name: 'dataDynamicCrud',
              queHago: 'A',
              valorCosto:Number(producto.costoUnitario),
              productosElaboradosId:this.productosIdParaGuardar,
              companiasId : companiaId,
              nombreTabla: 'productosElaborados'
            }
          }
          if(valorventa > 0 ){
            datos.valorVenta = valorventa
          }

          this.seguimientoIngresosStockProviders.actualizarPrecioProducto( datos)
      .subscribe(
        res => {
          this.utils.mensajeMuestroConCerrado('Editar producto','Se actualizo los valores del producto con exito','success',true)
        },(error)=> {
          console.log(error)
        })
      }})

    }


  }

  productosIdExiste(productosId: any): boolean {
    return this.datosproveedores.some(item => item.productosId === productosId);
  }

  searchCodigoBarra(cantidadafn:any,i:any){

    setTimeout(() => {

   if (typeof cantidadafn['value'] === 'string' && cantidadafn['value'] !== "") {
     const numericValue = Number(cantidadafn['value']);
     if (!isNaN(numericValue)) {
       // El valor es un número, se puede manejar normalmente
       this.codigoBarra = cantidadafn['value'];
     } else {
       // El valor es una cadena alfanumérica
       this.codigoBarra = cantidadafn['value'];
     }
   } else {
     // El valor no es una cadena o está vacío
     cantidadafn['value'] = "";
     return;
   }

   if (this.codigoBarra === "") {
     this.showBuscarProducto = true;
     return false;
   }
   this.storage.get('companiasId').then((val) => {
       if(!MODO_DESCONECTADO){
           this.servicioCompania.buscarCodigoBarra(val,this.codigoBarra)
           .debounceTime(3000)
           .subscribe(async (data)=>{
               if(NUBE_AWS){
                 let items = JSON.parse(data['_body']).data[0]
                 if(items.length>0){
                   let valores = items[0]
                   this.codigoBarra = valores.codigoBarra
                   this.codigoProducto = valores.codigoProducto
                   this.devolverValorCodigoBarra(valores)
                   // || items[0].codigoBarra !== ""
                   if(this.codigoBarra !== ""){

                     // this.codigoBarra = items[0].codigoBarra
                     // afnarqui mandar producto
                    //  this.aumentarUnProductoCodigoBarra(valores)
                   } else {

                   }
                   this.codigoBarra = ""
                   this.showBuscarProducto = false
               }else{

                     if (typeof cantidadafn['value'] === 'string') {
                       const numericValue = Number(cantidadafn['value']);
                       if (isNaN(numericValue)) {
                           this.buscarTexto = cantidadafn['value'];
                            let responseNombreBd = await this.servicioCompania.buscarProductosPorNombreTendero(val, this.buscarTexto)
                            let respuestaNombre = JSON.parse(responseNombreBd['_body']).data[0]
                            if(respuestaNombre.length > 0) {
                             this.listaProductos = respuestaNombre
                             this.showBuscarProducto = true;
                              return false;
                            }

                       }
                   }
                   this.codigoBarra = cantidadafn['value']
                   this.codigoProducto = cantidadafn['value']
                   this.showBuscarProducto = false
               }
             } else {
               if(data[0].length){

                 let valores = data[0][0]
                 if(this.codigoBarra !== ""){
                 }
                 this.codigoBarra = ""

             }else{
             }
             }

           },(error)=>{
               console.log(error)
           })}else{
           }

     });
   }, 1000);
 }


 toggleFormBuscarProductoClose() {
  this.showBuscarProducto = false;
  this.codigoBarra = ""
}
buscarProducto(event) {
  this.buscarTexto = event.value;
}
devolverValor(item) {
  if(item.productosId !== undefined) {
    this.productosId = item.productosId


    const productoEncontrado = this.listaProductos.find(p => p.productosId == item.productosId);
    if (productoEncontrado) {
      this.listaProductosCopiaAlmacenarTipo.push({
        productosId: productoEncontrado.productosId,
        tipoProducto: productoEncontrado.tipoProducto
      })
      // Tomar el último elemento de nuevacondicion y actualizarlo
      const ultimoRegistro = this.nuevacondicion[this.nuevacondicion.length - 1];

      // Si el último registro está vacío, lo llenamos
      if (!ultimoRegistro.productosId) {
        ultimoRegistro.productosId = productoEncontrado.productosId;
        ultimoRegistro.nombreProducto = productoEncontrado.nombreProducto;
      }
    }
    this.toggleFormBuscarProductoClose()
    this.codigoBarra = ""
  }
}


devolverValorCodigoBarra(producto:any) {
  if(producto.productosId !== undefined) {
    this.productosId = producto.productosId

    const productoEncontrado = producto;

    if (productoEncontrado) {
      // Tomar el último elemento de nuevacondicion y actualizarlo
      const ultimoRegistro = this.nuevacondicion[this.nuevacondicion.length - 1];

      // Si el último registro está vacío, lo llenamos
      if (!ultimoRegistro.productosId) {
        ultimoRegistro.productosId = productoEncontrado.productosId;
        ultimoRegistro.nombreProducto = productoEncontrado.nombreProducto;
      }
    }
    this.toggleFormBuscarProductoClose()
    this.codigoBarra = ""
  }
}

}



// WEBPACK FOOTER //
// ./src/pages/grid-proveedores/grid-proveedores.ts